module.exports = __webpack_public_path__ + "static/media/survive-short.a66de066.wav";